export type DealTableColumnStyleType = 'alignLeft' | 'alignCenter' | 'alignRight';
export type DealTableRateGroupType = 'rateGroupItem' | 'divide';
export interface DealTableRateGroupInterface {
  type: DealTableRateGroupType;
  title?: string;
  description?: string;
}
export class DealTableRateGroup implements DealTableRateGroupInterface {
  type!: DealTableRateGroupType;
}
export class DealTableRateGroupItem extends DealTableRateGroup {
  override type: DealTableRateGroupType = 'rateGroupItem';
  title: string | undefined;
  description: string | undefined;
  constructor(option: DealTableRateGroupInterface) {
    super();
    this.title = option.title;
    this.description = option.description;
  }
}
export class DealTableRateGroupDivide extends DealTableRateGroup {
  override type: DealTableRateGroupType = 'divide';
  constructor() {
    super();
  }
}
export class CkeditorPayload {
  executeName: string;
  payload: object;
  constructor(data: any) {
    this.executeName = data.executeName;
    this.payload = data.payload;
  }
}

export class DynamicFieldExecutePayload extends CkeditorPayload {
  override executeName = 'dynamicField';
  override payload: {
    key: string;
    label: string;
    value: string;
    type: string;
    metadata?: string;
  };
  constructor(option: {
    payload: {
      key: string;
      label: string;
      value: string;
      type: string;
      metadata?: string;
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
export class DynamicImageExecutePayload extends CkeditorPayload {
  override executeName = 'insertDynamicImage';
  override payload: {
    key: string;
    label: string;
    src: string;
  };
  constructor(option: {
    payload: {
      key: string;
      label: string;
      src: string;
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
export class AttributeInsertExecutePayload extends CkeditorPayload {
  override payload: {
    key: string;
    attributes: {
      attributeKey: string;
      value: string;
    }[];
  };
  constructor(option: {
    payload: {
      key: string;
      attributes: {
        attributeKey: string;
        value: string;
      }[];
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
export class DynamicFieldCreateOrUpdateExecutePayload extends AttributeInsertExecutePayload {
  override executeName = 'createOrUpdateDynamicFieldByMarker';
}
export class DynamicImageCreateOrUpdateExecutePayload extends AttributeInsertExecutePayload {
  override executeName = 'createOrUpdateByMarkerDynamicImage';
}
export class DynamicFieldAttributeInsertExecutePayload extends AttributeInsertExecutePayload {
  override executeName = 'insertAttributeDynamicField';
}
export class DynamicImageAttributeInsertExecutePayload extends AttributeInsertExecutePayload {
  override executeName = 'updateAttributeDynamicImage';
}
export class DynamicFieldDeleteExecutePayload extends CkeditorPayload {
  override executeName = 'deleteDynamicField';
  override payload: {
    key: string;
  };
  constructor(option: {
    payload: {
      key: string;
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
export class DynamicFieldAttributeExecutePayload extends CkeditorPayload {
  override executeName = 'insertAttributeDynamicField';
  override payload: {
    key: string;
    attributes: {
      attributeKey: string;
      value: string;
    }[];
  };
  constructor(option: {
    payload: {
      key: string;
      attributes: {
        attributeKey: string;
        value: string;
      }[];
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
export class NormalExecutePayload extends CkeditorPayload {
  override executeName!: string;
  constructor(option: { executeName: string; [x: string]: any }) {
    super(option);
  }
}
export class FieldExecutePayload extends CkeditorPayload {
  override executeName = 'insertSignatureField';
  override payload: {
    selectionId?: string;
    uuid?: string;
    email?: string;
    label: string;
    owner?: string;
  };
  constructor(option: {
    payload: {
      type: 'signatureField';
      selectionId?: string;
      uuid?: string;
      email?: string;
      label: string;
      owner?: string;
    };
  }) {
    super(option);
    option.payload.owner = option.payload.owner ? option.payload.owner : '';
    this.payload = option.payload;
  }
}

export class ParticipantFieldExecutePayload extends CkeditorPayload {
  override executeName: 'redrInlineTextField' | 'redrInlineDateField' = 'redrInlineTextField';
  override payload: {
    selectionId?: string;
    key?: string;
    uuid?: string;
    email?: string;
    label?: string;
    owner?: string;
    value?: string;
    metadata?: string;
  };
  constructor(option: {
    executeName?: 'redrInlineTextField' | 'redrInlineDateField';
    payload: {
      selectionId?: string;
      key?: string;
      uuid?: string;
      email?: string;
      label?: string;
      owner?: string;
      value?: string;
      metadata?: string;
    };
  }) {
    super(option);
    if (option.executeName) {
      this.executeName = option.executeName;
    }
    option.payload.owner = option.payload.owner ? option.payload.owner : '';
    this.payload = option.payload;
  }
}

export class ParticipantAttributeInsertExecutePayload extends AttributeInsertExecutePayload {
  override executeName = 'insertInlineFieldAttribute';
}

export class DealTableExecutePayload extends CkeditorPayload {
  override executeName = 'insertDealTable';
  override payload: {
    selectionId?: string;
    title?: string;
    dataTable: {
      config?: {
        hasHeader?: boolean;
        styleColumn?: DealTableColumnStyleType[];
      };
      data: string[][];
    };
    rateGroup: DealTableRateGroup[];
  };
  constructor(option: {
    payload: {
      selectionId?: string;
      title?: string;
      dataTable: {
        config?: {
          hasHeader?: boolean;
          styleColumn?: DealTableColumnStyleType[];
        };
        data: string[][];
      };
      rateGroup: DealTableRateGroup[];
    };
  }) {
    super(option);
    this.payload = option.payload;
  }
}
